import { render, staticRenderFns } from "./CloudArch.vue?vue&type=template&id=6c942fdc"
var script = {}
import style0 from "./CloudArch.vue?vue&type=style&index=0&id=6c942fdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports